// eslint-disable-next-line
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import RoutesComponent from './Routes/RoutesComponent';
import { CampaignProvider } from './Pages/Campaign/CreateCampaign/CampaignContext';


function App() {
  return (
    <div className="App" style={{ fontFamily: "'Inter', sans-serif" }}>
      <CampaignProvider>
      <BrowserRouter>
        <RoutesComponent />
      </BrowserRouter>
      </CampaignProvider>
    </div>
  );
}

export default App;